import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { I18nProvider } from "./i18n";
import { AuthProvider } from "./auth";
import TopNav from "./components/TopNav";
import CountryNudge from "./components/CountryNudge";
import PortalHero from "./components/PortalHero";
import MyWorld from "./components/MyWorld";
import ExploreByPlace from "./components/ExploreByPlace";
import Stories from "./components/Stories";
import WorldMap from "./components/WorldMap";
import Marquee from "./components/Marquee";
import HierarchyExplorer from "./components/HierarchyExplorer";
import Ecosystem from "./components/Ecosystem";
import Verticals from "./components/Verticals";
import PortalRouting from "./components/PortalRouting";
import KnowledgeGraph from "./components/KnowledgeGraph";
import Licensing from "./components/Licensing";
import Manifesto from "./components/Manifesto";
import Waitlist from "./components/Waitlist";
import Footer from "./components/Footer";
import PlacePage from "./components/PlacePage";
import CountryPage from "./components/CountryPage";
import StatePage from "./components/StatePage";
import DistrictPage from "./components/DistrictPage";
import CityPage from "./components/CityPage";
import HomeDiscussions from "./components/HomeDiscussions";
import DigestPage from "./components/DigestPage";
import CountriesDirectory from "./components/CountriesDirectory";
import CoverageDashboard from "./components/CoverageDashboard";

function Landing() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => document.getElementById(location.hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 400);
    }
  }, [location.hash]);

  return (
    <>
      <PortalHero onSearch={(q) => navigate(`/place/${q.toLowerCase().replace(/\s+/g, "-")}`)} />
      <MyWorld />
      <ExploreByPlace />
      <Stories />
      <HomeDiscussions />
      <WorldMap />
      <Marquee />
      <HierarchyExplorer />
      <Ecosystem />
      <Verticals />
      <PortalRouting />
      <KnowledgeGraph />
      <Licensing />
      <Manifesto />
      <Waitlist />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App wp-noise min-h-screen">
            <Toaster position="top-center" richColors />
            <TopNav />
            <CountryNudge />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/countries" element={<CountriesDirectory />} />
              <Route path="/country/:slug" element={<CountryPage />} />
              <Route path="/country/:country/:state" element={<StatePage />} />
              <Route path="/country/:country/:state/:district" element={<DistrictPage />} />
              <Route path="/country/:country/:state/:district/:city" element={<CityPage />} />
              <Route path="/place/:slug" element={<PlacePage />} />
              <Route path="/admin/coverage" element={<CoverageDashboard />} />
              <Route path="/digest" element={<DigestPage />} />
            </Routes>
            <Footer />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
